export const REDUCER_NAME = "matchNews";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_MATCHNEWS = `${REDUCER_NAME}/SET_MATCHNEWS`;

export const getKey = (data) => `${data.isFeatured || false}`;
